import React from 'react'
import SmartNavigator from '../generic/SmartNavigator'
import PrinterList from '../configuration/printers/PrinterList'
import PrintHistory from '../configuration/printers/PrintHistory'
import { useSmartTranslation } from '../generic/hooks/useSmartTranslation'

// Historia 226 (MIC-4441, D11): Configuration → Printers. Access is gated upstream (LeftMenu +
// MainMenuPermissionController, GENERATE_QR_CODE, RN45); every tab needs that same capability.
const MainPrinters = () => {
  const { t_ } = useSmartTranslation()
  const componentsInfo = [
    {
      title: t_('Printers'),
      component: <PrinterList />,
      permissionCode: 'GENERATE_QR_CODE'
    },
    {
      title: t_('History'),
      component: <PrintHistory />,
      permissionCode: 'GENERATE_QR_CODE'
    }
  ]
  return (
    <div>
      <SmartNavigator componentsInfo={componentsInfo} />
    </div>
  )
}

export default MainPrinters
